import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactPlayer from 'react-player';

interface VideoPlayerModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    videoUrl: string;
    description?: string;
}

const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({
    isOpen,
    onClose,
    title,
    videoUrl,
    description
}) => {
    if (!isOpen) return null;

    const modalContent = (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg shadow-xl w-full max-w-[60%] relative p-6"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-end items-center mb-4">
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-800">
                        <XMarkIcon className="w-4 h-4" onClick={onClose} />
                    </button>
                </div>
                <div
                    className="player-wrapper max-w-[98%] mx-auto rounded-lg overflow-hidden"
                    style={{ paddingTop: '56.25%', position: 'relative' }}
                >
                    <ReactPlayer
                        src={videoUrl}
                        className="absolute top-0 left-0"
                        width="100%"
                        height="100%"
                        controls
                        onError={() => {
                            /* swallow player errors silently */
                        }}
                    />
                </div>

                <div className="flex flex-col justify-start items-start mt-6 max-w-[98%] mx-auto">
                    <h3 className="text-xl font-bold text-gray-900">{title}</h3>
                    {description && <p className="text-gray-600 mt-2">{description}</p>}
                </div>
                <div className="flex justify-start">
                    <button
                        onClick={onClose}
                        className="mt-4 px-4 py-2 font-bold text-gray-800 text-xs rounded-lg hover:bg-gray-50 hover:underline hover:text-gray-800"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );

    const modalRoot = document.getElementById('modal-root');
    return modalRoot ? ReactDOM.createPortal(modalContent, modalRoot) : null;
};

export default VideoPlayerModal;
